import type { LocationEntity } from "../entities/LocationEntity.js";
import type { ILocationRepository } from "../repositories/ILocationRepository.js";

interface Deps {
  locationRepository: ILocationRepository;
}

export function createListLocationsByIdsInProjectUseCase({ locationRepository }: Deps) {
  return async function listLocationsByIdsInProject(
    orgId: string,
    projectId: string,
    locationIds: string[],
  ): Promise<LocationEntity[]> {
    return locationRepository.listByIdsInProject(orgId, projectId, locationIds);
  };
}
